module.exports = __webpack_public_path__ + "static/media/championshipStar.c84899b3.svg";